import axios from 'axios'
import { API_TYPE } from './IOCTypes'
import { AppAuthenticator } from '@auth/AppAuthenticator'
import { IOCContainer, ARCHBASE_IOC_API_TYPE } from '@archbase/core'
import { ArchbaseAccessTokenService, ArchbaseApiTokenService } from '@archbase/security'
import { ArchbaseAxiosRemoteApiClient, ArchbaseRemoteApiClient } from '@archbase/data'
import {
  DefaultArchbaseTokenManager,
  ArchbaseUserService,
  ArchbaseProfileService,
  ArchbaseGroupService,
  ArchbaseResourceService,
  ArchbaseTenantManager,
} from '@archbase/security'

/**
 * Configuração do Container IoC (Inversify)
 *
 * Este arquivo configura o container de injeção de dependências.
 * Registra todos os serviços necessários para o funcionamento do app.
 */

// Configura a URL base do Axios
axios.defaults.baseURL = import.meta.env.VITE_API

// Obtém o container singleton
const container = IOCContainer.getContainer()

// ============================================
// Configuração do Tenant (multi-tenancy)
// ============================================
// Configure o tenant padrão ou remova se não usar multi-tenancy
ArchbaseTenantManager.getInstance().setCurrentTenant({
  id: 'b1000000-0000-0000-0000-000000000001',
  descricao: 'RouteX Default Tenant',
} as any)

// ============================================
// Registro do Token Manager
// ============================================
IOCContainer.registerTokenManager(DefaultArchbaseTokenManager)

// ============================================
// Registro dos Serviços de Segurança
// ============================================
IOCContainer.registerSecurityServices({
  userService: ArchbaseUserService,
  profileService: ArchbaseProfileService,
  groupService: ArchbaseGroupService,
  resourceService: ArchbaseResourceService,
  accessTokenService: ArchbaseAccessTokenService,
  apiTokenService: ArchbaseApiTokenService,
})

// ============================================
// Registro do Autenticador Customizado
// ============================================
// Remove o autenticador padrão se existir para evitar conflito
if (IOCContainer.hasService(ARCHBASE_IOC_API_TYPE.Authenticator)) {
  IOCContainer.unbindService(ARCHBASE_IOC_API_TYPE.Authenticator)
}
IOCContainer.registerService(ARCHBASE_IOC_API_TYPE.Authenticator, AppAuthenticator)

// ============================================
// Registro do Cliente API
// ============================================
container.bind<ArchbaseRemoteApiClient>(API_TYPE.ApiClient).to(ArchbaseAxiosRemoteApiClient)

// ============================================
// RouteX.dev Services
// ============================================
import { RouteXApiClientService } from '@services/ApiClientService'
import { RouteXRouteJobService } from '@services/RouteJobService'
import { RouteXDashboardService } from '@services/DashboardService'
import { RouteXOptimizationService } from '@services/OptimizationService'

container.bind<RouteXApiClientService>(API_TYPE.RouteXApiClient).to(RouteXApiClientService)
container.bind<RouteXRouteJobService>(API_TYPE.RouteXRouteJob).to(RouteXRouteJobService)
container.bind<RouteXDashboardService>(API_TYPE.RouteXDashboard).to(RouteXDashboardService)
container.bind<RouteXOptimizationService>(API_TYPE.RouteXOptimization).to(RouteXOptimizationService)

export default container
